module.exports = __webpack_public_path__ + "static/media/salestabsimg.fe2e0d5d.png";